module.exports = __webpack_public_path__ + "media/parents/helpful-articles-813b6b7b.png";